<div class="modal right" id="newInvoice" tabindex="-1" role="dialog" aria-labelledby="newInvoiceLabel">
	<div class="modal-dialog" role="document">
		<div class="modal-content" id="print-content">
			<div class="modal-header hide-print">
				<div class="modal-title">
					<h4 id="newInvoiceLabel" ng-if="!invoice.id">New Invoice</h4>
					<h4 id="newInvoiceLabel" ng-if="invoice.id">Edit Invoice</h4>
				</div>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<i class="icon-close-circle"></i>
				</button>
			</div>
			<div class="modal-body order-detail-page">
				<div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
									<form ng-submit="save()" class="form-horizontal allcp-form">
										<div class="form-group floating">
											<input id="date" type="text" autocomplete="off"
												class="form-control input-md" placeholder="Date" required
												ng-model="invoice.date">
											<label>Date</label>
										</div>
										
										<div class="form-group floating">
											<select id="type" name="type" ng-model="invoice.invoice_type"
												class="form-control input-md" required
												ng-options="o.id as o.name for o in invoiceTypes">
												<option value="">Select Invoice Type</option>
											</select>
											<label>
												Invoice Type
											</label>
										</div>

										<div class="form-group floating">
											<select id="type" autocomplete="off" class="form-control input-md"
												name="type" ng-model="invoice.company_customer_id" required
												ng-options="o.id as o.customer_name for o in data.customers" 
												ng-change="getComissionRate()">
												<option value="">Select Partner</option>
											</select>
											<label>Partner</label>
										</div>

										<div class="form-group floating">
											<select id="type" name="type" ng-model="invoice.status"
												class="form-control input-md" required
												ng-options="o.id as o.name for o in statuses">
												<option value="">Select Status</option>
											</select>
											<label>
												Status
											</label>
										</div>

										<hr ng-if="invoice.invoice_type == 'comission_based'">
										
										<div class="form-group floating">
											<input type="text" ng-model="invoice.price" class="form-control input-md" placeholder="Price" required ng-if="invoice.invoice_type == 'order_based'">
											<input type="text" ng-model="invoice.price" class="form-control input-md" placeholder="Amount" ng-change="getTotalNumber()" required ng-if="invoice.invoice_type == 'comission_based'">
											<label ng-if="invoice.invoice_type == 'order_based'">Price</label>
											<label ng-if="invoice.invoice_type == 'comission_based'">Amount</label>
										</div>

										<div class="form-group floating">
											<input type="text" ng-model="invoice.qty" class="form-control input-md" placeholder="Qty" required ng-if="invoice.invoice_type == 'order_based'">
											<input type="text" ng-model="invoice.qty" class="form-control input-md" placeholder="Commission" required ng-if="invoice.invoice_type == 'comission_based'">
											<label ng-if="invoice.invoice_type == 'order_based'">Qty</label>
											<label ng-if="invoice.invoice_type == 'comission_based'">Commission</label>
										</div>

										<div class="form-group floating">
											<input type="text" ng-model="invoice.total" class="form-control input-md"
												placeholder="Total" required>
											<label>Total </label>
										</div>

										<div class="form-group floating">
											<textarea name="" id="" cols="5" rows="2" ng-model="invoice.description" class="form-control input-md"></textarea>
											<label>Description </label>
										</div>

										<div ng-repeat="elem in invoice.subInvoices">
											
											<hr>
											<div class="form-group floating">
												<input type="text" ng-model="elem.price" class="form-control input-md" placeholder="Amount" ng-change="getTotalNumber(elem)" required>
												<label>Amount</label>
											</div>
	
											<div class="form-group floating">
												<input type="text" ng-model="elem.qty" class="form-control input-md" placeholder="Commission" required>
												<label>Commission</label>
											</div>
	
											<div class="form-group floating">
												<input type="text" ng-model="elem.total" class="form-control input-md"
													placeholder="Total" required>
												<label>Total </label>
											</div>
	
											<div class="form-group floating">
												<textarea name="" id="" cols="5" rows="2" ng-model="elem.description" class="form-control input-md"></textarea>
												<label>Description </label>
											</div>
											
											<a href="#" class="hod-button red" ng-click="removeItem($index)">Remove</a>

											<hr>

										</div>

										<div class="row mb-2" ng-if="invoice.invoice_type == 'comission_based'">
											<div class="col">
												<a href="#" class="hod-button orange" ng-click="addItem()">Add new line</a>
											</div>
										</div>


										<div class="form-group floating pln">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue">
													<span ng-if="!invoice.id">CREATE</span>
													<span ng-if="invoice.id">UPDATE</span>
													</a>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>